var _defs, _circle, _circle2, _path, _path2, _path3, _rect, _path4;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgDiversity(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 75 75",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null)), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 14,
    cy: 17,
    r: 8,
    stroke: "#03BCAA",
    strokeDasharray: "2.74 2.74"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 62,
    cy: 39,
    r: 8,
    stroke: "#050505"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M62.5 9l8.227 14.25H54.273L62.5 9zM14 53l6.928 4v8L14 69l-6.928-4v-8L14 53zM38.5 31l8.227 14.25H30.273L38.5 31z",
    stroke: "#03BCAA",
    strokeDasharray: "2.74 2.74"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    stroke: "#050505",
    d: "M30 10h15v15H30z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    stroke: "#03BCAA",
    strokeDasharray: "2.74 2.74",
    d: "M55 53h15v15H55z"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 32,
    y: 53,
    width: 15,
    height: 15,
    rx: 7.5,
    stroke: "#050505"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    stroke: "#050505",
    d: "M13.484 31l8.485 8.485-8.485 8.485L5 39.485z"
  })));
}

var MemoSvgDiversity = /*#__PURE__*/React.memo(SvgDiversity);
export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNzUiIGhlaWdodD0iNzUiIHZpZXdCb3g9IjAgMCA3NSA3NSIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPGNpcmNsZSBjeD0iMTQiIGN5PSIxNyIgcj0iOCIgc3Ryb2tlPSIjMDNCQ0FBIiBzdHJva2UtZGFzaGFycmF5PSIyLjc0IDIuNzQiLz4KPGNpcmNsZSBjeD0iNjIiIGN5PSIzOSIgcj0iOCIgc3Ryb2tlPSIjMDUwNTA1Ii8+CjxwYXRoIGQ9Ik02Mi41IDlMNzAuNzI3MiAyMy4yNUg1NC4yNzI4TDYyLjUgOVoiIHN0cm9rZT0iIzAzQkNBQSIgc3Ryb2tlLWRhc2hhcnJheT0iMi43NCAyLjc0Ii8+CjxwYXRoIGQ9Ik0xNCA1M0wyMC45MjgyIDU3VjY1TDE0IDY5TDcuMDcxOCA2NVY1N0wxNCA1M1oiIHN0cm9rZT0iIzAzQkNBQSIgc3Ryb2tlLWRhc2hhcnJheT0iMi43NCAyLjc0Ii8+CjxwYXRoIGQ9Ik0zOC41IDMxTDQ2LjcyNzIgNDUuMjVIMzAuMjcyOEwzOC41IDMxWiIgc3Ryb2tlPSIjMDNCQ0FBIiBzdHJva2UtZGFzaGFycmF5PSIyLjc0IDIuNzQiLz4KPHJlY3QgeD0iMzAiIHk9IjEwIiB3aWR0aD0iMTUiIGhlaWdodD0iMTUiIHN0cm9rZT0iIzA1MDUwNSIvPgo8cmVjdCB4PSI1NSIgeT0iNTMiIHdpZHRoPSIxNSIgaGVpZ2h0PSIxNSIgc3Ryb2tlPSIjMDNCQ0FBIiBzdHJva2UtZGFzaGFycmF5PSIyLjc0IDIuNzQiLz4KPHJlY3QgeD0iMzIiIHk9IjUzIiB3aWR0aD0iMTUiIGhlaWdodD0iMTUiIHJ4PSI3LjUiIHN0cm9rZT0iIzA1MDUwNSIvPgo8cmVjdCB4PSIxMy40ODQ0IiB5PSIzMSIgd2lkdGg9IjEyIiBoZWlnaHQ9IjEyIiB0cmFuc2Zvcm09InJvdGF0ZSg0NSAxMy40ODQ0IDMxKSIgc3Ryb2tlPSIjMDUwNTA1Ii8+Cjwvc3ZnPgo=";
export { MemoSvgDiversity as ReactComponent };